import React, { useEffect, useState } from "react";
import "./addNew.scss";
import SideBar from "../../../../Components/SideBar/SideBar";
import Header from "../../../../Components/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { insertNew } from "../../../../api/newsApi/New";
import { Countries } from "../../../../api/CountryApi";
import { getallLang } from "../../../../api/LanguageApi/Lang";
import Select from "react-select";
import { useAlert } from "react-alert";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const AddNew = () => {
    const [selectedOption,   setSelectedOption]   = useState(null);
    const [productLocation,  setProductLocation]  = useState(null);
    const [imgs,             setImgs]             = useState([]);
    const [title,            setTitle]            = useState("");
    const [content,          setContent]          = useState("");
    const [archived,         setArchived]         = useState(0);
    const [createdAt,        setCreatedAt]        = useState("");
    const [error,            setError]            = useState("");

    const dispatch = useDispatch();
    const alert    = useAlert();

    /* ── file select: merge incoming into imgs, deduplicate ─────────── */
    const handleFileChange = (e) => {
        const incoming = Array.from(e.target.files);
        const MAX_IMAGES = 10; // optional limit

        setError("");
        if (imgs.length + incoming.length > MAX_IMAGES) {
            setError(`Maximum ${MAX_IMAGES} images allowed`);
            return;
        }

        setImgs((prev) => {
            const existing = new Set(prev.map((f) => f.name + f.size));
            const unique   = incoming.filter((f) => !existing.has(f.name + f.size));
            return [...prev, ...unique];
        });
        e.target.value = ""; // reset so same file can be re-added after delete
    };

    /* ── remove a single image from list ────────────────────────────── */
    const handleDeleteImg = (index) => {
        setImgs((prev) => prev.filter((_, i) => i !== index));
    };

    /* ── submit ──────────────────────────────────────────────────────── */
    const handleSubmit = (e) => {
        e.preventDefault();

        if (imgs.length === 0) {
            alert.show("Please upload at least one image");
            return;
        }

        const fd = new FormData();
        fd.append("title",    title    || "");
        fd.append("content",  content  || "");
        fd.append("archieved", archived);
        if (selectedOption?.value)  fd.append("language_id", selectedOption.value);
        if (productLocation?.value) fd.append("location",    productLocation.value);
        if (createdAt)              fd.append("created_at",  createdAt);

        // Send files as multipart array fields so backend receives multiple images.
        imgs.forEach((file) => fd.append("image[]", file, file.name));

        dispatch(insertNew(fd))
            .unwrap()
            .then(() => {
                alert.show("Sucessful Added");
                // reset form
                setTitle("");
                setContent("");
                setImgs([]);
                setArchived(0);
                setCreatedAt("");
                setSelectedOption(null);
                setProductLocation(null);
            })
            .catch((err) => {
                alert.show(err?.response?.data?.message ?? "Something went wrong.");
                console.log(err);
            });
    };

    const langs     = useSelector((state) => state?.Lang?.lang?.langs);
    const options   = langs?.map((l) => ({ value: l.id,   label: l.name }));
    const optionsCoun = Countries?.map((item) => ({ value: item.code, label: item.name }));

    useEffect(() => { dispatch(getallLang()); }, [dispatch]);

    /* ── table rows for image preview ───────────────────────────────── */
    const rows = imgs.map((file, index) => ({
        num: index + 1,
        imgEl: (
            <img
                src={URL.createObjectURL(file)}
                style={{ width: "60px", height: "60px", objectFit: "contain", borderRadius: 6 }}
                alt={file.name}
            />
        ),
        name:   file.name.length > 30 ? file.name.slice(0, 28) + "…" : file.name,
        action: (
            <button
                type="button"
                className="button2"
                onClick={() => handleDeleteImg(index)}
            >
                Delete
            </button>
        ),
    }));

    return (
        <div className="newContainer">
            <SideBar />
            <div className="NewWrapper">
                <Header title="Add News" />
                <div className="newBody">
                    <form className="addNewForm" onSubmit={handleSubmit}>
                        <h1>Add News</h1>

                        {/* Language */}
                        <div style={{ width: "20vw" }}>
                            <p>Language</p>
                            <Select value={selectedOption} onChange={setSelectedOption} options={options} />
                        </div>

                        {/* Country */}
                        <div style={{ width: "20vw" }}>
                            <p>Country</p>
                            <Select value={productLocation} onChange={setProductLocation} options={optionsCoun} />
                        </div>

                        {/* ── Multi-image upload ──────────────────────────────── */}
                        <div className="newInputFile">
                            <input
                                type="file"
                                name="image"
                                accept="image/*"
                                multiple
                                onChange={handleFileChange}
                            />
                            <small style={{ color: "#666", marginTop: "4px" }}>
                                {imgs.length} image(s) selected
                            </small>
                            {error && <small style={{ color: "red", marginTop: "4px" }}>{error}</small>}
                        </div>

                        {/* ── Image preview table ─────────────────────────────── */}
                        {imgs.length > 0 && (
                            <TableContainer style={{ marginBottom: 16 }}>
                                <Table sx={{ minWidth: 400 }} aria-label="images table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>#</TableCell>
                                            <TableCell align="right">Preview</TableCell>
                                            <TableCell align="right">Name</TableCell>
                                            <TableCell align="right">Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row) => (
                                            <TableRow
                                                key={row.num}
                                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">{row.num}</TableCell>
                                                <TableCell align="right">{row.imgEl}</TableCell>
                                                <TableCell align="right">{row.name}</TableCell>
                                                <TableCell align="right">{row.action}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}

                        {/* Title */}
                        <div className="newInput">
                            <span>title</span>
                            <input
                                type="text"
                                placeholder="name@example"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>

                        {/* Content */}
                        <div className="newInput">
                            <span>Content</span>
                            <input
                                className="contentNew"
                                type="text"
                                placeholder="Add Content"
                                value={content}
                                onChange={(e) => setContent(e.target.value)}
                            />
                        </div>

                        {/* Created At */}
                        <div className="newInput">
                            <span>Created At</span>
                            <input
                                type="date"
                                value={createdAt}
                                onChange={(e) => setCreatedAt(e.target.value)}
                            />
                        </div>

                        {/* Archived */}
                        <div className="newCheckBox">
                            <input
                                type="checkbox"
                                checked={!!archived}
                                onChange={() => setArchived(archived ? 0 : 1)}
                            />
                            <span>Archived</span>
                        </div>

                        <button className="buttonSave">Save</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddNew;